import React, {Component} from 'react';
//import { connect } from 'dva';
//import { Spin } from 'antd';
import Request from 'superagent';
import Dimio from './Dimio';
import _ from 'lodash';

class BaseComponent extends Component {
  constructor(props) {
    super(props);
/*
    this.state = {
      model: null
    }
    */
  }
/*
  t(label){
    const {labels} = this.props.meta;
    return (labels && labels[label])?labels[label]:label;
  }
*/
  gtmEvent(event, category, action){
    if(window.dataLayer) {
      window.dataLayer.push({
        event: event,
        eventCategory: category,
        eventAction: action
      });
    }
  }

  //-----------------------------------------------------------
  // Loading
  //-----------------------------------------------------------
  showLoading(){
    const {dispatch, appKey} = this.props;
    dispatch({
      type: `${appKey}/processing`,
      processing: true
    });
  }

  hideLoading(){
    const {dispatch, appKey} = this.props;
    dispatch({
      type: `${appKey}/processing`,
      processing: false
    });
  }

  //-----------------------------------------------------------
  // Message
  //-----------------------------------------------------------
/*
  showSuccess(message){
    const {dispatch} = this.props;
    dispatch({
      type: 'meta/showSuccess',
      success: message
    });
  }
  */

  showError(error){
    const {dispatch, appKey} = this.props;
    dispatch({
      type: `${appKey}/showError`,
      error: error
    });
  }

  hideError(){
    const {dispatch, appKey} = this.props;
    dispatch({
      type: `${appKey}/showError`,
      error: false
    });
  }

  //-----------------------------------------------------------
  // API
  //-----------------------------------------------------------
  load(url, options){
    const dimio = new Dimio();
    dimio.load(url,options);
  };
  save(url, options) {
    const dimio = new Dimio();
    dimio.save(url,options);
  }

  //-----------------------------------------------------------
  // Modal
  //-----------------------------------------------------------
  regModal(modalKey){
    const {dispatch, appKey} = this.props;
    console.info(this.props);
    dispatch({
      type: `${appKey}/regModal`,
      key: modalKey
    });
  }

  showModal(key, data){
    const {dispatch, appKey} = this.props;
    console.info(this.props);
    dispatch({
      type: `${appKey}/showModal`,
      key: key
    });
  }

  hideModal(key){
    const {dispatch, appKey} = this.props;
    console.info(appKey, key);
    dispatch({
      type: `${appKey}/hideModal`,
      key: key
    });
  }

}

export default BaseComponent;


// WEBPACK FOOTER //
// ./src/components/BaseComponent.js